<template>
    <div>
        <b-overlay opacity="0.6" :show="loading">
            <b-form>
                <b-card title="Stored cards">
                    <b-alert variant="danger" :show="addPaymentStatus == 3">
                        {{addPaymentStatusError}}
                    </b-alert>
                    <b-alert variant="warning" :show="paymentMethodsLoadStatus == 2 && paymentMethods.length == 0">
                        No payment method on file, please add a payment method.
                    </b-alert>

                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th>Type</th>
                            <th>Number</th>
                            <th>Action</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="(method, key) in paymentMethods" :key="'method-'+key">
                            <td>{{ method.brand.charAt(0).toUpperCase() }}{{ method.brand.slice(1) }}</td>
                            <td>Ending In: {{ method.last_four }} Exp: {{ method.exp_month }} / {{ method.exp_year }}
                            </td>
                            <td><span v-on:click.stop="removePaymentMethod( method.id )">Remove</span></td>
                        </tr>
                        </tbody>
                    </table>

                </b-card>

                <b-card title="Add new card">
                    <b-form-group label="Card">
                        <div id="card-element">

                        </div>
                    </b-form-group>

                    <b-form-group>
                        <b-button block size="lg" variant="primary" class="float-right" disabled v-if="loading">
                            <b-spinner small type="grow"></b-spinner>
                            Loading...
                        </b-button>
                        <b-button block size="lg" v-else v-on:click="submitPaymentMethod()" variant="primary">Save Payment
                            Method
                        </b-button>
                    </b-form-group>

                </b-card>
            </b-form>
        </b-overlay>
    </div>
</template>

<script>
    import {stripeKey, stripeTestKey} from "../../paymentConfig.json";
    import Vue from "vue";

    export default {
        data() {
            return {
                loading: false,
                stripeAPIToken: stripeKey,

                stripe: '',
                elements: '',
                card: '',

                intentToken: '',

                name: '',
                addPaymentStatus: 0,
                addPaymentStatusError: '',

                paymentMethods: [],
                paymentMethodsLoadStatus: 0,
                paymentMethodSelected: {},
            }
        },

        mounted() {
            Vue.loadScript("https://js.stripe.com/v3/").then(() => {
                this.configureStripe()
            });

            this.loadIntent();

            this.loadPaymentMethods();
        },

        methods: {
            configureStripe() {
                this.stripe = Stripe(this.stripeAPIToken);

                this.elements = this.stripe.elements();
                this.card = this.elements.create('card', {
                    hidePostalCode: true,
                    style: {
                        base: {
                            fontWeight: 500,
                            fontFamily: 'Raleway, sans-serif',
                            fontSize: '16px',
                            fontSmoothing: 'antialiased',
                        },
                    }
                });

                this.card.mount('#card-element');
            },

            /*
                Loads the payment intent key for the user to pay.
            */
            loadIntent() {
                axios.get('/user/setup-intent')
                    .then(function (response) {
                        this.intentToken = response.data;
                    }.bind(this));
            },

            /*
                Uses the intent to submit a payment method
                to Stripe. Upon success, we save the payment
                method to our system to be used.
            */
            submitPaymentMethod() {
                this.loading = true;
                this.addPaymentStatus = 1;
                console.log(this.intentToken.client_secret)
                this.stripe.confirmCardSetup(
                    this.intentToken.client_secret, {
                        payment_method: {
                            card: this.card
                        }
                    }
                ).then(function (result) {
                    if (result.error) {
                        this.loading = false;
                        this.addPaymentStatus = 3;
                        this.addPaymentStatusError = result.error.message;
                    } else {
                        this.loading = false;
                        this.savePaymentMethod(result.setupIntent.payment_method);
                        this.addPaymentStatus = 2;
                        this.card.clear();
                        this.name = '';
                        this.$toasted.show('Card has been added securely.');
                    }
                }.bind(this));
            },

            /*
                Saves the payment method for the user and
                re-loads the payment methods.
            */
            savePaymentMethod(method) {
                this.loading = true;
                axios.post('/user/payments', {
                    payment_method: method
                }).then(function () {
                    this.loading = false;
                    this.loadPaymentMethods();
                }.bind(this));
            },

            /*
                Loads all of the payment methods for the
                user.
            */
            loadPaymentMethods() {
                this.paymentMethodsLoadStatus = 1;
                this.loading = true;
                axios.get('/user/payment-methods')
                    .then(function (response) {
                        this.loading = false;
                        this.paymentMethods = response.data;

                        this.paymentMethodsLoadStatus = 2;
                        // this.setDefaultPaymentMethod();
                    }.bind(this));
            },

            removePaymentMethod(paymentID) {
                axios.post('/user/remove-payment', {
                    id: paymentID
                }).then(function (response) {
                    this.loadPaymentMethods();
                }.bind(this));
            },
        }

    }
</script>

<style scoped>

</style>